import { useTranslationInterface } from 'utils/hooks/useTranslation';

export const useBrandAffinityTranslation = () => useTranslationInterface('brandAffinity');
